import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { format, parse } from 'date-fns';
import { GLOBAL_DATE_FORMAT, globalBEDateFormat } from 'common/dateFormatConfig';
import formatNumber from '../../utils/formatNumber';
import PrintView from './PrintView';
import DayPrint from './DayPrint';
import { Field, WeekSummary } from './Rows';
import styles from './styles';

const useStyles = makeStyles(styles);
const formatDay = (date, pattern) => format(parse(date, globalBEDateFormat, new Date()), pattern);

const WeekPrint = () => {
  const classes = useStyles();
  const { users, weekSummary, loading } = useSelector((state) => state.timeclocks);
  const { summaries, weekHours, weekOvertime, weekShopTime } = weekSummary.data || {};

  if (loading || !summaries?.length) return null;

  const { profile, username } = users.current;
  const shortDate = (i) => formatDay(summaries[i].date, GLOBAL_DATE_FORMAT.shortDateWithDay);
  const week = `${shortDate(0)} - ${shortDate(summaries.length - 1)}`;

  return (
    <PrintView
      header={
        <div className={classes.head}>
          <div className={classes.subject}>
            {profile?.fullName || username}
            <span>{profile && `#${profile.employeeNum}`}</span>
          </div>
          <div>Week: {week}</div>
        </div>
      }
    >
      {summaries.map(({ date, summary }) => (
        <DayPrint
          key={date}
          title={formatDay(date, GLOBAL_DATE_FORMAT.fullDateWithDay)}
          summary={summary}
        />
      ))}
      <WeekSummary>
        <Field label="Hours This Week:">{formatNumber(weekHours)} hours</Field>
        <Field label="Overtime This Week:">{formatNumber(weekOvertime)} hours</Field>
        <Field label="Shop Time:">{formatNumber(weekShopTime)} hours</Field>
      </WeekSummary>
    </PrintView>
  );
};

export default WeekPrint;
